module.exports = __webpack_public_path__ + "img/attempted.1960cff1.svg";